import { render, staticRenderFns } from "./OcPendienteAct.vue?vue&type=template&id=4d76799a&scoped=true"
import script from "./OcPendienteAct.vue?vue&type=script&lang=js"
export * from "./OcPendienteAct.vue?vue&type=script&lang=js"
import style0 from "./OcPendienteAct.vue?vue&type=style&index=0&id=4d76799a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d76799a",
  null
  
)

export default component.exports